<template>
  <div class="container">
    <app-page-search :title="title"></app-page-search>
    <app-spinner v-if="loading"></app-spinner>
    <div v-else class="question-list">
      <div
        v-for="block in blocks"
        :class="{ active: openedBlock === block.guid }"
        :key="block.guid"
        :id="block.guid"
        class="block"
      >

        <div class="question" @click="toggleBlock(block.guid)">
          <div class="question__text" v-text="block.question"></div>

          <svg class="question__icon-play">
            <use xlink:href="#play"></use>
          </svg>
        </div>

        <div v-show="openedBlock === block.guid" class="answer">
          <div class="answer__text" v-html="block.answer"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AppPageSearch, AppSpinner } from "@/components";
import { loadFaq } from "@/api";

export default {
  name: "FAQ",
  components: { AppPageSearch, AppSpinner },
  data: () => ({
    title: "Вопрос - ответ",
    loading: false,
    blocks: [],
    openedBlock: ""
  }),
  watch: {
    $route() {
      this.checkRoute();
    }
  },
  async created() {
    this.blocks = await loadFaq();
    this.loading = false;

    this.checkRoute();
  },

  methods: {
    toggleBlock(id) {
      if (this.openedBlock !== id) {
        this.openedBlock = id;
        return;
      }
      this.openedBlock = this.openedBlock ? null : id;
    },
    checkRoute() {
      if (this.$route.query.guid) {
        this.openedBlock = this.$route.query.guid;

        this.$nextTick(() => {
          document.getElementById(this.$route.query.guid).scrollIntoView();
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.question-list {
  padding-top: 35px;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  color: #000000;
}
.loader {
  top: 50%;
}

.block {
  border: 1px solid #e5e5e5;
  padding: 0 42px;
  margin-bottom: 27px;
  cursor: pointer;

  &.active {
    .question__icon-play {
      transform: rotate(90deg);
    }
  }
}

.question {
  display: flex;
  align-items: center;
  padding: 30px 0;

  &__icon-play {
    width: 10px;
    height: 12px;
    align-self: center;
  }

  &__text {
    flex: 3;
    margin-bottom: 0;
    align-self: center;
    padding-right: 80px;
    color: #212529;
  }
}

.answer {
  padding-bottom: 30px;

  &__text {
    color: #797979;
    cursor: auto;
    font-size: 16px;
    line-height: 21px;
    font-weight: 400;
  }
}

@include media-breakpoint-down(md) {
  .question-list {
    font-size: 16px;
  }
  .question {
    &__text {
      padding-right: 20px;
      line-height: 20px;
    }
  }
  .answer {
    &__text {
      line-height: 25px;
    }
  }
}
</style>
